import React from "react";
import "./Home.scss";
import SlideShow from "../../components/slideshow/SlideShow";
import ProductCat from "../../components/productCat/ProductCat";
import FeaturedProducts from "../../components/FeaturedProducts/FeaturedProducts";
import GoogleMap from "../../components/googleMap/GoogleMap";
import Categories from "../../components/Categories/Categories";
import HeroText from "../../components/heroText/HeroText";
import Newsletter from "../../components/Newsletter/Newsletter";



const Home = () => {

  return (
    <div className="max-width">
      <div className="home">
        <div className="__hero">
          <SlideShow />
        </div>
        <br />
        <HeroText/>
        <div className="__mw">
          <Categories/>
        </div>
      <br />

        {/* <div className="__mw">
          <div className="cont_wrp">
            <FeaturedProducts type="trending" />
          </div>
          <div className="cont_wrp">
            <FeaturedProducts type="offer" />
          </div>
        </div> */}
      </div>
      <br />
      <Newsletter/>
      <br />
      <GoogleMap />
      <br />
    </div>
  );
};

export default Home;
